import { lazy, Suspense } from 'react';
import { useReferralModalStore } from '@/stores/referralModal';

const ReferralModal = lazy(() => import('./modal').then(module => ({ default: module.ReferralModal })));

/**
 * 全局 老带新 弹窗容器
 */
export default function ReferralModalLoadable() {
  const visible = useReferralModalStore(state => state.visible);

  if (!visible) {
    return null;
  }

  return (
    <Suspense fallback={null}>
      <ReferralModal />
    </Suspense>
  );
}
